import KunLoading104 from './src/index'

KunLoading104.install = function (Vue) {
	Vue.component(KunLoading104.name, KunLoading104);
}

export default KunLoading104;
